import fetch from 'utils/fetch';
import {
  ArchivalAidMetadata,
  ArchivalCollection,
  ArchivalUnitCopy,
  Params,
  Result,
} from 'types';

type EsmDestination =
  | 'nad-sheet'
  | 'archival-aid'
  | 'archival-unit'
  | 'archival-unit-public';

export interface RedirectFromESMProps {
  redirectFrom: EsmDestination;
  /**
   * ID that is exactly the same in BADATELNA AND ESM
   *
   * for example:
   *  - "numericId" sent as id - redirect from ARCHIVAL UNIT ESM
   *  - "evidenceNumber" sent as id - redirect from NAD SHEET ESM
   *  - "evidenceNumber" sent as id - redirect from ARCHIVAL AID ESM
   */
  id: string;
}

export async function getRedirectUrl(
  esmDestination: EsmDestination,
  id: string
) {
  let apiParameters = {
    url: '',
    filterField: 'evidenceNumber',
  };

  let redirectUrl = '';

  switch (esmDestination) {
    case 'nad-sheet':
      apiParameters = {
        ...apiParameters,
        url: '/api/archival-collection/list',
      };
      redirectUrl = 'fondy/0';
      break;
    case 'archival-aid':
      apiParameters = {
        ...apiParameters,
        url: '/api/archival-aid-metadata/list',
      };
      redirectUrl = 'pomucky/0';
      break;
    case 'archival-unit-public':
      apiParameters = {
        url: '/api/archival-unit/public/list',
        filterField: 'numericId',
      };
      redirectUrl = 'pomucky/1';
      break;
  }

  const params: Params = {
    filters: [
      {
        operation: 'EQ',
        field: apiParameters.filterField,
        value: id,
      },
    ],
  };

  const response = await fetch(apiParameters.url, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(params),
  });

  const result: Result<
    ArchivalUnitCopy | ArchivalAidMetadata | ArchivalCollection
  > = await response.json();

  let entityId = '';

  if (result.items?.length) {
    entityId = result.items[0].id;
  }

  return {
    // returns correct entity ID which is known within badatelna scope
    entityId,
    redirectUrl,
  };
}
